import React from 'react';
import { config } from '../../config';
import { Box, Card, CardContent, CardMedia, Typography } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { AppChargeType, AppPricePlanDetailsType } from '../../types/generated';
import { getAppOverviewPriceType, sortPricePlansByPrice } from './AppStoreUtils';

const StyledCardMedia = styled(CardMedia)`
    overflow: hidden;
    width: 80px;
    height: 80px;
    margin-bottom: 24px;
    background-size: contain;
    border-radius: 12px;
`;

const StyledCard = styled(Card)`
    display: flex;
    flex-direction: column;
    height: 100%;
    cursor: pointer;
    border: 1px solid rgb(221, 221, 221);
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.04);

    &:hover {
        border-color: rgb(29, 87, 199);
        box-shadow: rgba(40, 130, 200, 0.11) 0px 5px 10px 5px;
    }
`;

const StyledCardContent = styled(CardContent)`
    flex: 1;
    padding-bottom: 16px !important;
`;

interface AppCardProps {
    id: string;
    title: string;
    tagLine: string;
    imageUrl: string;
    priceType: AppChargeType;
    pricePlans: AppPricePlanDetailsType[];
    freeTrialDays: number;
    oneTimeChargeAmount: number;
}

export const appInstallLink = (appId: string): string => `${config.baseUrl}/appstore/open/` + appId;

export const AppCard = ({
    id,
    title,
    tagLine,
    imageUrl,
    priceType,
    pricePlans,
    freeTrialDays,
    oneTimeChargeAmount,
}: AppCardProps): JSX.Element => {
    const navigate = useNavigate();

    const bookingFeePercentageOfDisplayedPlan =
        sortPricePlansByPrice(pricePlans)[0]?.plan.bookingFeePercentage;

    return (
        <StyledCard onClick={() => navigate('/app-details/' + id)}>
            <StyledCardContent>
                <Box
                    display={'flex'}
                    flexDirection={'column'}
                    justifyContent={'space-between'}
                    height={'100%'}
                >
                    <div>
                        <StyledCardMedia image={imageUrl} />
                        <Typography gutterBottom variant="h6" component="h5">
                            {title}
                        </Typography>
                        <Typography variant={'body2'}>{tagLine}</Typography>
                    </div>
                    <Typography align={'right'} style={{ fontWeight: 700, paddingTop: '16px' }}>
                        {getAppOverviewPriceType(
                            priceType,
                            oneTimeChargeAmount,
                            pricePlans,
                            freeTrialDays
                        )}
                    </Typography>
                    {bookingFeePercentageOfDisplayedPlan ? (
                        <Typography
                            align={'right'}
                            style={{ fontStyle: 'italic', fontSize: '1em' }}
                        >
                            + {bookingFeePercentageOfDisplayedPlan}% booking fee
                        </Typography>
                    ) : null}
                </Box>
            </StyledCardContent>
        </StyledCard>
    );
};
